import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../Button/Button';
import ButtonTypes from '../../../constants/buttonTypes';
import { permissions } from '../../../common/permissionGroup';
import PermissionsGate from '../../PermissionsGate/PermissionsGate';

const RoleCardFooter = ({ onButtonView, onButtonEdit, onDelete }) => {
  return (
    <div className="flex flex-row justify-start">
      {onButtonView && (
        <Button
          type={ButtonTypes.LIGHT_PRIMARY}
          text="View Role"
          containerStyle="mr-[10px]"
          onClick={onButtonView}
        />
      )}
      {onButtonEdit && (
        <PermissionsGate can={permissions.ROLES_UPDATE}>
          <Button
            type={ButtonTypes.LIGHT}
            text="Edit Role"
            onClick={onButtonEdit}
            containerStyle="mr-[10px]"
          />
        </PermissionsGate>
      )}
      {onDelete && (
        <PermissionsGate can={permissions.ROLES_DELETE}>
          <Button type={ButtonTypes.DANGER} text="Delete Role" onClick={onDelete} />
        </PermissionsGate>
      )}
    </div>
  );
};

RoleCardFooter.propTypes = {
  onButtonEdit: PropTypes.func,
  onButtonView: PropTypes.func,
  onDelete: PropTypes.func,
};

RoleCardFooter.defaultProps = {
  onButtonEdit: undefined,
  onButtonView: undefined,
  onDelete: undefined,
};

export default RoleCardFooter;
